import { OnTranscriptUpdate } from './types';
import useMessageHandler from './useEddyMessaging/useMessageHandler';

export type TranscriptUpdateMessageData = {
  type: 'transcriptUpdate';
  transcriptId: string;
};

export type UseTranscriptUpdateMessagingProps = {
  iframe?: HTMLIFrameElement | null;
  onTranscriptUpdate?: OnTranscriptUpdate;
};

export default function useTranscriptUpdateMessaging({
  iframe,
  onTranscriptUpdate,
}: UseTranscriptUpdateMessagingProps) {
  useMessageHandler<TranscriptUpdateMessageData>(
    e => {
      if (e.data.type === 'transcriptUpdate') {
        onTranscriptUpdate?.();
      }
    },
    { iframe },
  );
}
